var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 931,
    viewBox: "0 0 361 931",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 930,
    transform: "translate(1 1)",
    fill: "black",
    fillOpacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 0.625,
    x2: 360.25,
    y2: 0.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 30.625,
    x2: 360.25,
    y2: 30.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 60.625,
    x2: 360.25,
    y2: 60.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 90.625,
    x2: 360.25,
    y2: 90.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 120.625,
    x2: 360.25,
    y2: 120.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 150.625,
    x2: 360.25,
    y2: 150.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 180.625,
    x2: 360.25,
    y2: 180.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 210.625,
    x2: 360.25,
    y2: 210.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 240.625,
    x2: 360.25,
    y2: 240.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 270.625,
    x2: 360.25,
    y2: 270.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 300.625,
    x2: 360.25,
    y2: 300.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 330.625,
    x2: 360.25,
    y2: 330.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 360.625,
    x2: 360.25,
    y2: 360.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 390.625,
    x2: 360.25,
    y2: 390.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 420.625,
    x2: 360.25,
    y2: 420.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 450.625,
    x2: 360.25,
    y2: 450.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 480.625,
    x2: 360.25,
    y2: 480.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 510.625,
    x2: 360.25,
    y2: 510.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 540.625,
    x2: 360.25,
    y2: 540.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 570.625,
    x2: 360.25,
    y2: 570.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 600.625,
    x2: 360.25,
    y2: 600.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 630.625,
    x2: 360.25,
    y2: 630.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 660.625,
    x2: 360.25,
    y2: 660.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 690.625,
    x2: 360.25,
    y2: 690.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 720.625,
    x2: 360.25,
    y2: 720.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 750.625,
    x2: 360.25,
    y2: 750.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 780.625,
    x2: 360.25,
    y2: 780.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 810.625,
    x2: 360.25,
    y2: 810.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 840.625,
    x2: 360.25,
    y2: 840.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 870.625,
    x2: 360.25,
    y2: 870.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 900.625,
    x2: 360.25,
    y2: 900.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 930.625,
    x2: 360.25,
    y2: 930.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 0.625,
    y1: 931,
    x2: 0.624974,
    y2: 1,
    stroke: "white",
    strokeWidth: 0.75
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 30.625,
    y1: 931,
    x2: 30.625,
    y2: 1,
    stroke: "white",
    strokeWidth: 0.75
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 60.625,
    y1: 931,
    x2: 60.625,
    y2: 1,
    stroke: "white",
    strokeWidth: 0.75
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 90.625,
    y1: 931,
    x2: 90.625,
    y2: 1,
    stroke: "white",
    strokeWidth: 0.75
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 120.625,
    y1: 931,
    x2: 120.625,
    y2: 1,
    stroke: "white",
    strokeWidth: 0.75
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 150.625,
    y1: 931,
    x2: 150.625,
    y2: 1,
    stroke: "white",
    strokeWidth: 0.75
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 180.625,
    y1: 931,
    x2: 180.625,
    y2: 1,
    stroke: "white",
    strokeWidth: 0.75
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 210.625,
    y1: 931,
    x2: 210.625,
    y2: 1,
    stroke: "white",
    strokeWidth: 0.75
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 240.625,
    y1: 931,
    x2: 240.625,
    y2: 1,
    stroke: "white",
    strokeWidth: 0.75
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 270.625,
    y1: 931,
    x2: 270.625,
    y2: 1,
    stroke: "white",
    strokeWidth: 0.75
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 300.625,
    y1: 931,
    x2: 300.625,
    y2: 1,
    stroke: "white",
    strokeWidth: 0.75
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 330.625,
    y1: 931,
    x2: 330.625,
    y2: 1,
    stroke: "white",
    strokeWidth: 0.75
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 360.625,
    y1: 931,
    x2: 360.625,
    y2: 1,
    stroke: "white",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridWhite);
export default __webpack_public_path__ + "static/media/grid_white.8da25d36fe7e898ee3b09e06f495b571.svg";
export { ForwardRef as ReactComponent };